export enum PROCTORING_TYPE {
  RECORD_ONLY = 'Record Only',
  PRACTICE = 'Practice',
  FULL_PROCTORING = 'Full Proctoring',
  SECURE_BROWSER_ONLY_NO_PROCTORING = 'Secure Browser Only (No Proctoring)',
}
export interface ExamFormValues {
  name: string;
  start: Date | null;
  end: Date | null;
  url: string;
  password: string;
  proctoringOption: PROCTORING_TYPE | '';
  secureBrowserSettings: {
    enabled: boolean;
    disableNavigation: boolean;
    disablePrintScreen: boolean;
    disableCopyPaste: boolean;
    forceFullScreen: boolean;
    enableWhitelistedUrls: boolean;
    whitelistedUrls: string;
  };
}
